import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * OAuthCallback Component
 * Handles the OAuth redirect callback from the provider
 */
import { useEffect, useState } from 'react';
import { trpc } from '../utils/trpc';
export function OAuthCallback({ onSuccess, onError }) {
    const [status, setStatus] = useState('processing');
    const handleCallback = trpc.oauth.handleCallback.useMutation({
        onSuccess: async (data) => {
            // Set session cookie via worker endpoint
            try {
                const workerUrl = import.meta.env.DEV
                    ? 'http://localhost:8787'
                    : 'https://api.ghnf.baskiers.dev';
                await fetch(`${workerUrl}/auth/set-session`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include',
                    body: JSON.stringify({ sessionToken: data.sessionToken }),
                });
                // Store session token in localStorage as backup for WebSocket auth
                localStorage.setItem('sessionToken', data.sessionToken);
                localStorage.setItem('user', JSON.stringify(data.user));
                setStatus('success');
                onSuccess();
            }
            catch {
                setStatus('error');
                onError('Failed to set session');
            }
        },
        onError: (error) => {
            setStatus('error');
            onError(error.message);
        },
    });
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');
        const storedState = sessionStorage.getItem('oauth_state');
        const provider = sessionStorage.getItem('oauth_provider');
        if (!code || !state) {
            setStatus('error');
            onError('Missing OAuth parameters');
            return;
        }
        if (state !== storedState) {
            setStatus('error');
            onError('Invalid OAuth state - possible CSRF attack');
            return;
        }
        if (!provider) {
            setStatus('error');
            onError('Missing OAuth provider info');
            return;
        }
        // Clean up stored state
        sessionStorage.removeItem('oauth_state');
        sessionStorage.removeItem('oauth_provider');
        // Exchange code for session
        handleCallback.mutate({ provider, code, state });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return (_jsxs("div", { className: "flex items-center justify-center min-h-[200px]", children: [status === 'processing' && (_jsxs("div", { className: "text-center", children: [_jsx("div", { className: "animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4" }), _jsx("p", { className: "text-gray-600 dark:text-gray-400", children: "Completing sign in..." })] })), status === 'success' && (_jsx("div", { className: "text-center", children: _jsx("p", { className: "text-green-600 dark:text-green-400 font-medium", children: "Successfully signed in! Redirecting..." }) })), status === 'error' && (_jsx("div", { className: "text-center", children: _jsx("p", { className: "text-red-600 dark:text-red-400 font-medium", children: "Sign in failed. Please try again." }) }))] }));
}
